"use strict";
// Copyright (c) 2021 by Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.Viewer = void 0;
const composition_api_1 = require("@vue/composition-api");
const Container_1 = require("../Container");
const Viewer_hook_1 = require("./Viewer.hook");
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
exports.Viewer = (0, composition_api_1.defineComponent)({
    name: 'Viewer',
    components: { Container: Container_1.Container },
    props: Viewer_hook_1.viewerProps,
    setup: Viewer_hook_1.useViewer,
    template: `
    <div :id="id" class="viewer">
      <component v-if="gridTemplate" is="style" v-html="gridTemplate" />

      <Container class="viewer__container" v-for="(c, i) in structureToDisplay" :key="'container-'+c.container+'-'+i"
                 :containers="containers" :definition="c" :index="i" :columns="resolvedConfig.columns"
                 :controls="resolvedConfig.controls" innerClass="viewer__container-inner"
                 :component="containerComponent" :elementProps="elementProps">
  
        <component class="viewer__module" :is="moduleComponent"
                   v-for="(m, j) in c.modules" :key="'module-'+m.module+'-'+j"
                   :definition="m" :containerIndex="i" :index="j" :modules="modules"
                   :controls="resolvedConfig.controls" :columns="resolvedConfig.columns"
                   :elementProps="elementProps" />
      </Container>
    </div>
  `
});
//# sourceMappingURL=Viewer.js.map